import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import { ifAuthenticated } from "../access";

import CustomTemplates from "@/pages/Pages/Custom/CustomTemplates.vue";
import CustomTemplate from "@/pages/Pages/Custom/CustomTemplate.vue";
import CustomDetail from "@/pages/Pages/Custom/CustomDetail.vue";
import CustomDetailInfo from "@/pages/Pages/Custom/CustomDetailInfo.vue";
import CustomGroup from "@/pages/Pages/Custom/CustomGroup.vue";
import CustomProviderTariffs from "@/pages/Pages/Custom/CustomProviderTariffs.vue";
import CustomProviderTariff from "@/pages/Pages/Custom/CustomProviderTariff.vue";
import CustomPartnerTariffs from "@/pages/Pages/Custom/CustomPartnerTariffs.vue";
import CustomPartnerTariff from "@/pages/Pages/Custom/CustomPartnerTariff.vue";

const customMenu = {
    path: "/custom",
    component: DashboardLayout,
    beforeEnter: ifAuthenticated,
    redirect: "/custom/detail",
    name: "Custom",
    children: [
        {
            path: "templates",
            name: "custom_templates",
            components: { default: CustomTemplates },
            meta: {
                icon: "inbox",
                msgKey: 'menu.item.custom.templates'
            }
        },
        {
            path: "templates/new",
            name: "custom_templates_new",
            components: { default: CustomTemplate },
            meta: {
                icon: "inbox",
                parentPath: "/custom/templates",
                msgKey: 'menu.item.custom.templates'
            },
        },
        {
            path: "templates/:id",
            name: "custom_templates_edit",
            components: { default: CustomTemplate },
            meta: {
                icon: "inbox",
                parentPath: "/custom/templates",
                msgKey: 'menu.item.custom.templates'
            }
        },
        {
            path: "detail",
            name: "custom_detail",
            components: { default: CustomDetail },
            meta: {
                icon: "inbox",
                msgKey: 'menu.item.statistics.custom.detail'
            },
        },
        {
            path: "detail/:id",
            name: "custom_detail_info",
            components: { default: CustomDetailInfo },
            meta:{
                icon: "inbox",
                parentPath: "/custom/detail",
                msgKey: 'menu.item.statistics.custom.detail'
            }
        },
        {
            path: "group",
            name: "custom_group",
            components: { default: CustomGroup },
            meta: {
                icon: "inbox",
                msgKey: 'menu.item.statistics.custom.group'
            },
        },
        {
            path: "partners/tariffs",
            name: "custom_client_tariff",
            components: { default: CustomPartnerTariffs },
            meta: {
                icon: "inbox",
                msgKey: 'menu.item.custom.clients.tariff',
            }
        },
        {
            path: "partners/tariffs/new",
            name: "custom_client_tariff_new",
            components: { default: CustomPartnerTariff },
            meta: {
                icon: "inbox",
                parentPath: "/custom/partners/tariffs",
                msgKey: 'menu.item.custom.clients.tariff',
            },
        },
        {
            path: "partners/tariffs/:id",
            name: "custom_client_tariff_edit",
            components: { default: CustomPartnerTariff },
            meta: {
                icon: "inbox",
                parentPath: "/custom/partners/tariffs",
                msgKey: 'menu.item.custom.clients.tariff',
            }
        },
        {
            path: "service_providers/tariffs",
            name: "custom_provider_tariff",
            components: { default: CustomProviderTariffs },
            meta: {
                icon: "inbox",
                msgKey: 'menu.item.custom.provider.tariff',
            }
        },
        {
            path: "service_providers/tariffs/new",
            name: "custom_provider_tariff_new",
            components: { default: CustomProviderTariff },
            meta: {
                icon: "inbox",
                parentPath: "/custom/service_providers/tariffs",
                msgKey: 'menu.item.custom.provider.tariff',
            },
        },
        {
            path: "service_providers/tariffs/:id",
            name: "custom_provider_tariff_edit",
            components: { default: CustomProviderTariff },
            meta: {
                icon: "inbox",
                parentPath: "/custom/service_providers/tariffs",
                msgKey: 'menu.item.custom.provider.tariff',
            }
        },
    ],
};

export default customMenu;
